import { useEffect, useState } from "react";
import commonStyles from "../../styles/Common.module.css";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TextField,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    IconButton,
    MenuItem,
    TableContainer,
    Paper,
    TablePagination,
    Chip
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import moment from "moment";
import { Link } from "react-router-dom";


const statuses = [
    "New Lead",
    "Contacted",
    "Call not received",
    "Requested Information",
    "Interested",
    "Converted",
    "Not Interested",
    "Follow-up Scheduled",
    "Wrong Number",
    "Not Now",
];

const statusColors = {
    "New Lead": "default",
    "Contacted": "primary",
    "Call not received": "warning",
    "Requested Information": "info",
    "Interested": "success",
    "Converted": "success",
    "Not Interested": "error",
    "Follow-up Scheduled": "info",
    "Wrong Number": "error",
    "Not Now": "warning",
};

export const MentorCallbackRequests = () => {
    const [users, setUsers] = useState([]);
    const [selected, setSelected] = useState(null);
    const [updates, setUpdates] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [newUpdate, setNewUpdate] = useState({ remark: "", update_status: "", next_call_date: "" });
    const [page, setPage] = useState(0);
    const [totalDocuments, settoTalDocuments] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    useEffect(() => {
        fetchUsers();
    }, [page, rowsPerPage]);

    const fetchUsers = async () => {
        const { data } = await axios.post(`https://api.sovrenn.com/mentor-callback-requests/list?page=${page + 1}&page_size=${rowsPerPage}`, {}, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("sov_user"),
            },
        });
        setUsers(data.data);
        settoTalDocuments(data.pagination.total_documents);
    };

    const updateField = async (id, key, value) => {
        await axios.patch(`https://api.sovrenn.com/mentor-callback-requests/${id}`, { [key]: value }, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("sov_user"),
            },
        });
        fetchUsers();
    };

    const openDialog = async (user) => {

        setSelected(user);
        setUpdates(user.updates.reverse());
        setDialogOpen(true);
    };

    const handleAddUpdate = async () => {
        await axios.post(`https://api.sovrenn.com/mentor-callback-requests/${selected._id}/add-update`, newUpdate, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("sov_user"),
            },
        });
        setNewUpdate({ remark: "", update_status: "", next_call_date: "" });
        fetchUsers();
        setDialogOpen(false);
        setSelected(null);
    };


    return (
        <div className={commonStyles.MainContainer}>

            <div className={commonStyles.headerDiv}>
                <Typography variant="h5">
                    CRM - Callback Requests
                </Typography>

            </div>

            <TableContainer component={Paper} style={{ maxHeight: "85vh" }}>
                <Table stickyHeader size="small">
                    <TableHead style={{ padding: 0 }}>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Phone</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Last Update</TableCell>
                            <TableCell>Updated By</TableCell>
                            <TableCell>Update</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {users.map((u) => {
                            const lastUpdate = u.updates?.[u.updates.length - 1];
                            return (
                                <TableRow key={u._id}>
                                    <TableCell>
                                        <Link to={`/users/${u.user_id._id}`} target="_blank" style={{ textDecoration: "none" }}>
                                            {u.user_id?.first_name?.toUpperCase()} {u.user_id?.last_name?.toUpperCase()}
                                        </Link>
                                    </TableCell>

                                    <TableCell>{u.user_id?.phone_number}</TableCell>
                                    <TableCell>{u.user_id?.email}</TableCell>
                                    <TableCell>
                                        <Chip
                                            label={u.status || "N/A"}
                                            color={statusColors[u.status] || "default"}
                                            // variant="outlined"
                                            size="small"
                                        />
                                    </TableCell>
                                    <TableCell>{moment(u.createdAt).format("Do MMM, h:mm A")}</TableCell>
                                    <TableCell>
                                        {lastUpdate ? (
                                            <Typography variant="body2">
                                                {moment(lastUpdate.updated_at).format("Do MMM, h:mm A")}
                                            </Typography>
                                        ) : "-"}
                                    </TableCell>
                                    <TableCell>
                                        {lastUpdate ? (
                                            <Typography variant="body2">
                                                {lastUpdate.updated_by.first_name + " " + lastUpdate.updated_by.last_name}
                                            </Typography>
                                        ) : "-"}
                                    </TableCell>
                                    <TableCell>
                                        <IconButton onClick={() => openDialog(u)}>
                                            <EditIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            <TablePagination
                component="div"
                count={totalDocuments || -1}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                    setRowsPerPage(parseInt(e.target.value));
                    setPage(0);
                }}
                rowsPerPageOptions={[50, 100, 200]}
                // labelDisplayedRows={() => ""}
                nextIconButtonProps={{ disabled: users.length < rowsPerPage }}
            />

            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} fullWidth maxWidth="md">
                <DialogTitle>Updates On - <span style={{ fontWeight: "bold" }} >
                    {selected?.user_id?.first_name.toUpperCase()} {selected?.user_id?.last_name.toUpperCase()}
                </span></DialogTitle>
                <DialogContent>
                    <div style={{ maxHeight: 300, overflowY: "auto", paddingRight: 10 }}>
                        {updates.map((up, idx) => (
                            <div
                                key={idx}
                                style={{
                                    marginBottom: 15,
                                    borderBottom: "1px solid #ddd",
                                    paddingBottom: 6
                                }}
                            >
                                <Typography style={{ fontSize: "large" }}>
                                    <strong>{up.update_status}</strong> on {moment(up.updated_at).format("Do MMM, h:mm A")}
                                </Typography>
                                <Typography style={{
                                    marginTop: 2,
                                    paddingBottom: 2
                                }}>{up.remark}</Typography>
                                <Typography variant="caption" style={{ fontSize: "medium" }}>
                                    Next Call: {up.next_call_date ? moment(up.next_call_date).format("Do MMM YY") : "-"}
                                </Typography>
                                <Typography variant="caption" style={{ marginLeft: 20, fontSize: "medium" }}>
                                    Updated By: {up.updated_by?.first_name} {up.updated_by?.last_name}
                                </Typography>
                            </div>
                        ))}
                    </div>

                    <Typography variant="h6" gutterBottom style={{
                        marginTop: 10
                    }}>Add New Update</Typography>
                    <TextField
                        fullWidth
                        label="Remark"
                        multiline
                        value={newUpdate.remark}
                        onChange={(e) => setNewUpdate({ ...newUpdate, remark: e.target.value })}
                        style={{ marginBottom: 10 }}
                    />
                    <TextField
                        select
                        fullWidth
                        label="Status"
                        value={newUpdate.update_status}
                        onChange={(e) => setNewUpdate({ ...newUpdate, update_status: e.target.value })}
                        style={{ marginBottom: 10 }}
                    >
                        {statuses.map((status) => (
                            <MenuItem key={status} value={status}>{status}</MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        fullWidth
                        type="date"
                        label="Next Call Date"
                        InputLabelProps={{ shrink: true }}
                        value={newUpdate.next_call_date}
                        onChange={(e) => setNewUpdate({ ...newUpdate, next_call_date: e.target.value })}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)}>Close</Button>
                    <Button onClick={handleAddUpdate} variant="contained">Add Update</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
